import { writable } from "svelte/store";
export var Common;
(function (Common) {
    Common.filter = writable({});
    Common.transactions = writable([]);
})(Common || (Common = {}));
